"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReviewsSortingDropdown", {
  enumerable: true,
  get: function () {
    return _ReviewsSortingDropdown.ReviewsSortingDropdown;
  }
});
var _ReviewsSortingDropdown = require("./ReviewsSortingDropdown");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUmV2aWV3c1NvcnRpbmdEcm9wZG93biIsInJlcXVpcmUiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SZXZpZXdzL1Jldmlld3NTb3J0aW5nRHJvcGRvd24vaW5kZXgudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFJldmlld3NTb3J0aW5nRHJvcGRvd24gfSBmcm9tIFwiLi9SZXZpZXdzU29ydGluZ0Ryb3Bkb3duXCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSx1QkFBQSxHQUFBQyxPQUFBIiwiaWdub3JlTGlzdCI6W119